<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="row m-0 pb-md-2 mt-1">
    <div class="card-deck m-0 px-0 pr-md-2 col-md-3 mb-md-4" v-for="(el, index) in model.catsdetails">
      <card-child-document @testing="callExternalFunction" v-bind:parentcatsortid="el.SortOrder"  v-bind:parentcatid="el.CategoryId"  ref="myComponent" v-bind:el="el" v-bind:allcategories="model.allcategories"
                           v-bind:Lables="model.Lables" v-bind:ADVANCED="model.ADVANCED" v-bind:UserPermissionLevel="model.UserPermissionLevel"></card-child-document>
    </div>
  </div>
</template>

<script>
  import CardChildDocument from '../document/card-child-document.vue'
  export default {
    name: "card-document",
    components: {
      CardChildDocument
    },
    props: {

    },
    data() {
      return {
        model: {},
      };
    },
    methods: {
      callExternalFunction(t) {
        alert(t);
        //alert("callextenal");
        // Pass the component instance to the external function
        externalFunction(t);
      },

      getId() {
        return this._uid;
      },

    },
    watch: {

    },
    mounted() {

    },
    computed: {

    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/document/card-document.vue